<template>
    <Dialog
            :value="value"
            @input="$listeners.input"
            :unlimit-height="true"
            title="ATENÇÃO!"
            width="500"
    >
        <div class="description">
            <p class="description-text ">
                Justifique a alteração no status:
            </p>

            <m-form ref="form" @submit.prevent="submitJustification">
                <m-text-field
                        id="fieldJustification"
                        v-model="justificativa"
                        :rules="[minCharactersRule]"
                        placeholder="Insira a justificativa"
                        maxlength="800"
                        outlined
                        autocomplete="off"
                        class="required"
                />
            </m-form>

            <div class="actions text-right">
                <v-btn
                        color="secondary"
                        class="mr-3"
                        @click="closeDialog"
                >
                    CANCELAR
                </v-btn>
                <v-btn
                        color="primary"
                        @click="submitJustification"
                >
                    CONFIRMAR
                </v-btn>
            </div>
        </div>
    </Dialog>
</template>

<script>
  export default {
    name: 'DialogChangeStatusUser',
    props: {
      value: { type: Boolean, required: true }
    },
    data: () => ({
      justificativa: ''
    }),
    computed: {
      minCharactersRule () {
        return (v) =>
          (v && v.length >= 20) || 'A justificativa deve ter no mínimo 20 caracteres.'
      }
    },
    methods: {
      closeDialog () {
        this.justificativa = ''
        this.$emit('input', false)
        this.$emit('reload')
      },
      submitJustification () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$emit('submit', this.justificativa)
          this.closeDialog()
        }
      }
    }
  }
</script>

<style scoped>
.description-text {
  text-align: justify;
  font-size: 1rem;
}
.actions {
  text-align: right;
}
</style>
